import { useNavigate, useParams } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import NewCategoryModalContainer from 'modules/surveys/components/Questions/Categories/NewCategoryModalContainer'

const SurveyAddCategoryPage = () => {
  const { navigation } = useNavigation()

  const navigate = useNavigate()
  const { question_group_config_id, id } = useParams()

  const onClose = () =>
    navigate(navigation.processes.surveys.id.questions.fullPath({ id: String(id) }))

  return (
    <NewCategoryModalContainer
      formId={id ?? ''}
      onClose={onClose}
      questionGroupConfigId={question_group_config_id ?? ''}
    />
  )
}

export default SurveyAddCategoryPage
